import { render, staticRenderFns } from "./ModalLock.vue?vue&type=template&id=509d2bb8&scoped=true&"
import script from "./ModalLock.vue?vue&type=script&lang=js&"
export * from "./ModalLock.vue?vue&type=script&lang=js&"
import style0 from "./ModalLock.vue?vue&type=style&index=0&id=509d2bb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509d2bb8",
  null
  
)

export default component.exports